import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingFarmPrimaryData } from "services";

import { FOOTPRINTING_FARM, FOOTPRINTING_FARM_PRIMARY_DATA } from "consts";

export const useSubmitFootprintingFarmPrimaryData = (farmId: string, year: number, primaryDataId: string) => {
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_FARM_PRIMARY_DATA],
      mutationFn: async () => setFootprintingFarmPrimaryData({ farmId, year, isSubmitted: true }, primaryDataId),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_FARM_PRIMARY_DATA, primaryDataId],
          [FOOTPRINTING_FARM_PRIMARY_DATA, farmId, year],
          [FOOTPRINTING_FARM, farmId, year],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
